import React, { Fragment } from "react";

import Header from "@components/Header";
import Footer from "@components/Footer";

import "../styles/main.scss";

const Layout: React.FC = ({ children }) => {
  return (
    <Fragment>
      <Header />

      <main>{children}</main>

      <Footer />
    </Fragment>
  );
};

export default Layout;
